import { CurrentUserResponse } from '../api/responses/api-response-types';

export class User {
  permissions: Array<string> = [];

  constructor(payload: CurrentUserResponse) {
    this.permissions = payload.permissions;
  }

  get hasTermsAndConditionsAdmin(): boolean {
    return this.permissions.some(e => e === 'legal_pages_admin');
  }
}
